export default "__VITE_ASSET__$z8OD$Ky__"